import React from 'react';
import {Section,SectionHeader} from '../ui/Section';

export const Minimums=()=> {
const minimums=[
  {day: "Weekdays", price: "$16,000", bg: "bg-white"},
  {day: "Friday", price: "$23,000", bg: "bg-white"},
  {day: "Saturdays & Holidays", price: "$31,000", bg: "bg-aged-ivory border-estate-bronze/30", featured: true},
  {day: "Sunday", price: "$20,000", bg: "bg-white"},
];

return (
  <Section id="minimums" bg="bg-vintage-white">
    <SectionHeader 
      title="Event Minimum Requirements" 
      subtitle="Excluding alcohol. Minimum spend requirements vary based on the day of the week." 
    />
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6 max-w-[1200px] mx-auto">
      {minimums.map((min,idx)=> (
        <div key={idx} className={`p-10 rounded-[2rem] border flex flex-col items-center justify-center text-center transition-all duration-500 hover:-translate-y-2 ${min.bg} ${min.featured ? 'shadow-xl ring-1 ring-estate-bronze/20 z-10' : 'border-warm-stone/40'}`}>
          <span className="text-xs uppercase tracking-widest text-deep-charcoal/50 font-bold mb-4">{min.day}</span>
          <span className={`font-serif text-4xl lg:text-5xl ${min.featured ? 'text-olive-grove' : 'text-deep-charcoal'}`}>{min.price}</span>
          {min.featured && (
            <span className="mt-4 text-[9px] uppercase tracking-widest text-estate-bronze font-black">Peak Date</span>
          )}
        </div>
      ))}
    </div>
    <div className="mt-12 max-w-2xl mx-auto text-center">
      <div className="inline-block p-6 md:p-8 rounded-2xl bg-white border border-warm-stone/20 shadow-sm">
        <p className="text-sm md:text-base text-deep-charcoal/70 font-light leading-relaxed">
          <strong className="font-medium text-deep-charcoal">Note:</strong> Final pricing depends on guest count, menu selection, bar selection, rentals, enhancements, administrative fee, tax, and event details.
        </p>
      </div>
    </div>
  </Section>
);
};